// Shared YouTube API Loader
// This ensures the YouTube iframe API is only loaded once

let youtubeApiLoaded = false;
let youtubeApiLoading = false;
const callbacks = [];

export const loadYouTubeAPI = (callback) => {
  if (youtubeApiLoaded && window.YT && window.YT.Player) {
    callback();
    return;
  }

  callbacks.push(callback);

  if (youtubeApiLoading) {
    return;
  }

  youtubeApiLoading = true;

  // Check if script already exists
  const existingScript = document.querySelector('script[src*="youtube.com/iframe_api"]');
  if (existingScript) {
    if (window.YT && window.YT.Player) {
      youtubeApiLoaded = true;
      youtubeApiLoading = false;
      callbacks.forEach(cb => cb());
      callbacks.length = 0;
      return;
    }
    // Wait for existing script to load
    const checkInterval = setInterval(() => {
      if (window.YT && window.YT.Player) {
        youtubeApiLoaded = true;
        youtubeApiLoading = false;
        clearInterval(checkInterval);
        callbacks.forEach(cb => cb());
        callbacks.length = 0;
      }
    }, 100);
    return;
  }

  // Create and load script - use privacy-enhanced mode
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  tag.async = true;
  tag.defer = true;
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // Store original handler if it exists
  const originalHandler = window.onYouTubeIframeAPIReady;
  
  window.onYouTubeIframeAPIReady = () => {
    youtubeApiLoaded = true;
    youtubeApiLoading = false;
    
    // Call original handler if it exists
    if (originalHandler && typeof originalHandler === 'function') {
      originalHandler();
    }
    
    // Call all our callbacks
    callbacks.forEach(cb => cb());
    callbacks.length = 0;
  };
};

